import { MessageCircle, Mail } from "lucide-react";
import { CONTACT, TID } from "@/data/site";

const Contact = () => {
  return (
    <section
      id="contact"
      data-testid={TID.contactSection}
      className="section relative bg-aegean grain"
    >
      <div className="max-w-4xl mx-auto px-5 lg:px-10">
        <div className="grid sm:grid-cols-2 gap-4">
          <a
            href={`https://wa.me/${CONTACT.phoneRaw}`}
            target="_blank"
            rel="noreferrer"
            data-testid={TID.contactWhatsapp}
            className="group rounded-3xl glass-strong p-6 lift block"
          >
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-emerald-500/15 text-emerald-300 border border-emerald-400/25">
              <MessageCircle className="h-5 w-5" />
            </span>
            <div className="mt-4 text-[0.7rem] uppercase tracking-[0.2em] text-foreground/55">
              WhatsApp
            </div>
            <div className="mt-1 font-display text-xl text-foreground group-hover:text-gold transition-colors">
              {CONTACT.phone}
            </div>
            <div className="mt-2 text-xs text-foreground/55">Chat 24/7 →</div>
          </a>

          <a
            href={`mailto:${CONTACT.email}`}
            data-testid={TID.contactEmail}
            className="group rounded-3xl glass-strong p-6 lift block"
          >
            <span className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-gold/15 text-gold border border-gold/30">
              <Mail className="h-5 w-5" />
            </span>
            <div className="mt-4 text-[0.7rem] uppercase tracking-[0.2em] text-foreground/55">
              Email
            </div>
            <div className="mt-1 font-display text-xl text-foreground group-hover:text-gold transition-colors break-all">
              {CONTACT.email}
            </div>
            <div className="mt-2 text-xs text-foreground/55">
              Reply within minutes →
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
